import type { AppProps } from 'next/app'
import '../styles/globals.css';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import '@fortawesome/fontawesome-free/css/all.css';
import ReactGA from 'react-ga4';
import { useEffect } from "react";
import { CommentProvider } from '../contexts/CommentContext';
import { CommentTypeProvider } from '../contexts/CommentTypeContext';
import { VisibleCommentTypesProvider } from '../contexts/VisibleCommentTypesContext';
import { SearchBboxProvider } from '../contexts/SearchBboxContext';
import ErrorBoundary from '../features/platform/ErrorBoundary';
import { ToastContainer } from 'react-toastify';
import { store } from '../app/store'
import { Provider } from 'react-redux'
import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import Head from 'next/head';

function MyApp({ Component, pageProps }: AppProps) {

  useEffect(() => {
    initializeFaro({
      url: process.env.NEXT_PUBLIC_GRAFANA_COLLECTOR_URL,
      app: {
        name: 'spect-ai-beta',
        version: '1.0.0',
        environment: process.env.NODE_ENV
      },
      instrumentations: [
        ...getWebInstrumentations(),
        new TracingInstrumentation(),
      ],
    });

    ReactGA.initialize('G-JKBLWX4RQD');
  }, []);

  return (
    <>
      <Head>
        <link rel="icon" href="/WhiteOrange.svg" type="image/svg+xml" />
        <script
          dangerouslySetInnerHTML={{
            __html: `!function(w,d,i,s){function l(){if(!d.getElementById(i)){var f=d.getElementsByTagName(s)[0],e=d.createElement(s);e.type="text/javascript",e.async=!0,e.src="https://canny.io/sdk.js",f.parentNode.insertBefore(e,f)}}if("function"!=typeof w.Canny){var c=function(){c.q.push(arguments)};c.q=[],w.Canny=c,"complete"===d.readyState?l():w.attachEvent?w.attachEvent("onload",l):w.addEventListener("load",l,!1)}}(window,document,"canny-jssdk","script");`
          }}
        />
      </Head>
      <Provider store={store}>
        <ErrorBoundary>
          <CommentProvider>
            <CommentTypeProvider>
              <SearchBboxProvider>
                <VisibleCommentTypesProvider>
                  <Component {...pageProps} />
                </VisibleCommentTypesProvider>
              </SearchBboxProvider>
            </CommentTypeProvider>
          </CommentProvider>
        </ErrorBoundary>
        <ToastContainer />
      </Provider>
    </>
  );
}

export default MyApp;
